$(document).ready(function () {
  const scratchCaGiftId = 10122459840812;
  const freeShilajitGummies = [10119167279404, 10107773157676, 10119167050028];
  // Collect selected product IDs from customization settings
  let giftIdsToHide = $('safe-sticky[data-hidden-kaching-bundle-gifts]').attr('data-hidden-kaching-bundle-gifts') || '';

  giftIdsToHide = giftIdsToHide
    .split(',')
    .map(id => parseInt(id.trim(), 10))
    .filter(id => !isNaN(id));

  giftIdsToHide.push(scratchCaGiftId, ...freeShilajitGummies);
  giftIdsToHide = Array.from(new Set(giftIdsToHide));

  const convertIdtoGID = id => `gid://shopify/Product/${id}`;

  // Reusable waitForEl function using jQuery
  function waitForEl(selector, cb, attr, interval, timeout) {
    interval = interval || 100;
    timeout = timeout || 10000;
    let t = 0;
    const intv = setInterval(function () {
      const $el = $(selector);
      if ($el.length && (!attr || $el.attr(attr))) {
        clearInterval(intv);
        cb($el);
      } else if ((t += interval) >= timeout) {
        clearInterval(intv);
      }
    }, interval);
  }

  waitForEl('kaching-bundles-block', function ($el) {
    const deal = JSON.parse($el.attr('deal-block') || '{}');
    const hiddenGiftProducts = [];

    const giftGIDsToHide = giftIdsToHide.map(convertIdtoGID);
    $.each(deal.dealBars || [], function (_, dealBar) {
      $.each(dealBar.freeGifts || [], function (_, gift) {
        // Check if any of the GIDs to hide match the free gift's productGID
        if (giftGIDsToHide.includes(gift.productGID) && gift.id) {
          hiddenGiftProducts.push(gift.id);
        }
      });
    });

    waitForEl('.kaching-bundles__free-gift', function ($giftEls) {
      $giftEls.each(function () {
        const giftId = $(this).attr('data-free-gift-id');
        if (hiddenGiftProducts.includes(giftId)) $(this).hide();
      });
    }, null, 100, 5000);
  }, 'deal-block');
});